import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=090b5a80&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=090b5a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b5a80",
  null
  
)

export default component.exports